export enum CustomerType {
    new = 0,
    exist = 1
}
